// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2ZpJL","content":"LoadingAlert_content__3MA7R"};